// Memory only: cached validation never grants backend permissions. A new app
// instance starts empty, and concurrent callers share the same validation.
export function createSessionCache(ttl = 60000) {
  const entries = new Map();
  return {
    peek: token => entries.get(token)?.data,
    clear(token) { if (token) entries.delete(token); else entries.clear(); },
    verify(token, loader, force = false) {
      const prior = entries.get(token);
      if (prior?.pending) return prior.pending;
      if (!force && prior?.data && Date.now() - prior.at < ttl) return Promise.resolve(prior.data);
      const entry = { ...prior };
      entry.pending = Promise.resolve().then(loader).then(data => {
        if (entries.get(token) === entry) {
          entries.set(token, { data, at: Date.now() });
          if (data.token && data.token !== token) entries.set(data.token, { data, at: Date.now() });
        }
        return data;
      }, error => { if (entries.get(token) === entry) { if ([401,403,404].includes(error?.response?.status)) entries.delete(token); else entries.set(token, { data: prior?.data, at: 0 }); } throw error; });
      entries.set(token, entry);
      return entry.pending;
    }
  };
}

